export const FACTORIES = [
    "埼玉工場",
    "野木工場",
    "泉佐野工場",
    "札幌工場",
    "吉野ヶ里工場",
    "N/A"
];

export const PATHS = {
    login: '/login',
    confirm: '/confirm',
    userSettings: '/userSettings',
    estimations: '/estimations/:department/:itemNameId?',
    itemDetails: '/itemDetails/:department/:itemNameId',
    itemList: '/itemList/:department',
    campaigns: '/campaigns/:department',
    addMenu: '/addMenu/:department',
    factoryDetails: '/factoryDetails/:factoryName'
};

export const APPLEPIE_API_ROOT = process.env.REACT_APP_APPLEPIE_API_ROOT;
